import { PropsWithChildren } from 'react';
import { XIcon } from 'lucide-react';

import styles from './full-view-dialog.module.scss';

export type DialogHeaderProps = PropsWithChildren;

const DialogHeader = ({ children }: DialogHeaderProps) => (
    <header>
        {children}
        <div className={styles.closeIcon} data-model="full-view-dialog-close">
            <XIcon size={18} />
        </div>
    </header>
);

export { DialogHeader };
